export enum LanguageEnum {
    DA = 0,
    EN = 1
}